module.exports = __webpack_public_path__ + "img/0016.c8416b7f.jpg";